import { fromJS, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

import { ApprovalCustomWorkflowMetadataStage } from './ApprovalCustomWorkflowMetadataStage';

export class ApprovalCustomWorkflowMetadata extends Record<{
  name: string;
  stage: ApprovalCustomWorkflowMetadataStage;
}>({
  name: '',
  stage: new ApprovalCustomWorkflowMetadataStage(),
}) {}

export const createApprovalCustomWorkflowMetadata = (
  props: CreateFunctionInput<ApprovalCustomWorkflowMetadata> = {},
) => {
  if (props instanceof ApprovalCustomWorkflowMetadata) {
    return props;
  }
  let customWorkflowMetadata = new ApprovalCustomWorkflowMetadata(fromJS(props));
  customWorkflowMetadata = customWorkflowMetadata.withMutations((cwMetadata) => {
    cwMetadata.update('stage', (stage) => new ApprovalCustomWorkflowMetadataStage(stage));
  });
  return customWorkflowMetadata;
};
